import { useMemo, useState } from 'react';
import {
  MaterialReactTable,
  useMaterialReactTable,
  MRT_EditActionButtons,
} from 'material-react-table';
import { IconButton, Tooltip, TextField } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
// import RefreshIcon from '@mui/icons-material/Refresh';
import { Box, DialogTitle, Button, DialogContent, DialogActions } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import Autocomplete from "react-google-autocomplete";
import axios from 'axios';
//import "./style_table2.css";
import { mkConfig, generateCsv, download } from 'export-to-csv'; //or use your library of choice here
import {
  QueryClient,
  QueryClientProvider,
  useMutation,
  keepPreviousData,
  useQuery,
  useQueryClient,

} from '@tanstack/react-query';
//Your API response shape will probably be different. Knowing a total row count is important though.

const csvConfig = mkConfig({
  fieldSeparator: ';',
  decimalSeparator: '.',
  useKeysAsHeaders: true,
  });

const Example = () => {
  //manage our own state for stuff we want to pass to the API
  const [validationErrors, setValidationErrors] = useState({});
  const { REACT_APP_API_ENDPOINT } = process.env;
  
  // Stati per Google Maps Autocomplete
  const [places, setPlaces] = useState('');
  const [location, setLocation] = useState({});
  const [mapCitta, setMapCitta] = useState('');
  const [mapRegione, setMapRegione] = useState('');
  const [mapCAP, setMapCAP] = useState('');
  const [mapProvincia, setMapProvincia] = useState('');
  const [values, setValues] = useState({});
  // Snackbar state
  const [snack, setSnack] = useState({ open: false, message: '', severity: 'success' });
  const showSnackbar = (message, severity = 'success') => setSnack({ open: true, message, severity });
  const handleSnackClose = (_, reason) => {
    if (reason === 'clickaway') return;
    setSnack((s) => ({ ...s, open: false }));
  };
  //consider storing this code in a custom hook (i.e useFetchUsers)
  const {
    data: { data = [] } = {}, //your data and api response will probably be different
    isError: isLoadingUsersError,
    isRefetching,
    isLoading: isLoadingUsers,
    // refetch,
  } = useQuery({
    queryKey: ['table-data'],
    queryFn: async () => {
  const fetchURL = new URL(`${REACT_APP_API_ENDPOINT}/api/garages/garages`);

      //use whatever fetch library you want, fetch, axios, etc
      const response = await fetch(fetchURL.href);
      const json = (await response.json());
      return json;
    },
    staleTime: 5000, // I dati sono considerati freschi per 5 secondi
    refetchOnMount: true, // Refetch quando il componente viene montato
    refetchOnWindowFocus: false, // Non refetch quando la finestra torna in focus
    placeholderData: keepPreviousData, //don't go to 0 rows when refetching or paginating to next page
  });

  const columns = useMemo(
    //column definitions...
    () => [
      {
        accessorKey: '_id',
        header: '_id',
        filterVariant: 'text', // default
        enableEditing: false,
        size: 80,
      },
      {
        accessorKey: 'regione',
        header: 'Regione',
        filterVariant: 'text', // default
        size: 100,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.regione,
          helperText: validationErrors?.regione,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              regione: undefined,
            }),

          //optionally add validation checking for onBlur or onChange
        },
      },
      {
        accessorKey: 'recapito',
        header: 'Recapito',
        filterVariant: 'text', // default
        size: 100,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.recapito,
          helperText: validationErrors?.recapito,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              recapito: undefined,
            }),

          //optionally add validation checking for onBlur or onChange
        },
      },
      {
        accessorKey: 'localita',
        header: 'Localita',
        filterVariant: 'text', // default
        size: 100,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.localita,
          helperText: validationErrors?.localita,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              localita: undefined,
            }),

          //optionally add validation checking for onBlur or onChange
        },
      },
      {
        accessorKey: 'indirizzo',
        header: 'Indirizzo',
        filterVariant: 'text', // default
        size: 200,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.indirizzo,
          helperText: validationErrors?.indirizzo,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              indirizzo: undefined,
            }),

          //optionally add validation checking for onBlur or onChange
        },
      },
      {
        accessorKey: 'CAP',
        header: 'CAP',
        filterVariant: 'text', // default
        size: 80,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.CAP,
          helperText: validationErrors?.CAP,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              CAP: undefined,
            }),

          //optionally add validation checking for onBlur or onChange
        },
      },
      {
        accessorKey: 'provincia',
        header: 'PROV.',
        filterVariant: 'text', // default
        size: 80,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.provincia,
          helperText: validationErrors?.provincia,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              provincia: undefined,
            }),

          //optionally add validation checking for onBlur or onChange
        },
      },
      {
        accessorKey: 'lat',
        header: 'lat.',
        filterVariant: 'text', // default
        size: 200,
        Cell: ({ cell }) => {
          return <div style={{color: 'orangered'}}>{cell.getValue()}</div>;
        },
      },
      {
        accessorKey: 'lng',
        header: 'lng.',
        filterVariant: 'text', // default
        size: 200,
        Cell: ({ cell }) => {
          return <div style={{color: 'orangered'}}>{cell.getValue()}</div>;
        },
      },
    ],
    [validationErrors],
    //end
  );

  //call CREATE hook
  const { mutateAsync: createUser, isPending: isCreatingUser } = useCreateUser();
  const { mutateAsync: updateUser, isPending: isUpdatingUser } = useUpdateUser();
  //call DELETE hook
  const { mutateAsync: deleteUser, isPending: isDeletingUser } = useDeleteUser();

    const handleExportRows = (rows, fileName = "report-depositi") => {
    const rowData = rows.map((row) => row.original);
    // Crea una nuova configurazione con il nome personalizzato
    const customConfig = { ...csvConfig, filename: fileName };
    const csv = generateCsv(customConfig)(rowData);
    download(customConfig)(csv);
  };
  //CREATE action (Garages)

  const handleCreateUser = async ({
    table,
  }) => {
    // Validazione campi obbligatori per Garages
    if (!places || !mapRegione || !mapCitta || !values.recapito) {
      showSnackbar('Compila tutti i campi obbligatori: Indirizzo e Recapito sono richiesti', 'warning');
      return;
    }

    const payload = {
      regione: mapRegione,
      localita: mapCitta,
      recapito: values.recapito,
      indirizzo: places,
      CAP: mapCAP,
      provincia: mapProvincia,
      lat: location.lat,
      lng: location.lng
    };

    setValidationErrors({});

    try {
      // Await per aspettare che la mutazione finisca completamente
      await createUser(payload);

      // Reset degli stati dopo la creazione SOLO se ha avuto successo
  setPlaces('');
      setLocation({});
      setMapCitta('');
      setMapRegione('');
      setMapCAP('');
      setMapProvincia('');
      setValues({});

      table.setCreatingRow(null); //exit creating mode
      showSnackbar('Deposito creato con successo', 'success');
    } catch (error) {
      console.error('Errore durante la creazione:', error);
      // Non chiudere il modal in caso di errore, così l'utente può riprovare
      showSnackbar(error?.message || 'Errore durante la creazione', 'error');
    }

  };

  //READ hook (get users from api)

  //UPDATE action (Garages)

  const handleSaveUser = async ({
    values,
    table,
  }) => {
    const newValidationErrors = validateGarage(values);
    if (Object.values(newValidationErrors).some((error) => error)) {
      setValidationErrors(newValidationErrors);
      return;
    }

    setValidationErrors({});
    try {
      await updateUser(values);
      table.setEditingRow(null); //exit editing mode
      showSnackbar('Deposito aggiornato', 'success');
    } catch (e) {
      console.error('Errore aggiornamento deposito:', e);
      showSnackbar(e?.message || 'Errore aggiornamento deposito', 'error');
    }
  };


  //DELETE action

  const openDeleteConfirmModal = async (row) => {

    if (window.confirm('Sei sicuro di voler eliminare questo deposito?')) {
      try {
        await deleteUser(row.original._id);
        showSnackbar('Deposito eliminato', 'success');
      } catch (e) {
        console.error('Errore durante l\'eliminazione del deposito:', e);
        const serverMsg = e?.response?.data?.message;
        showSnackbar(serverMsg || e?.message || 'Errore eliminazione deposito', 'error');
      }

    }

  };

  // Handler per Google Maps Autocomplete
  const HandleonPlacesChanged = (place) => {
    setPlaces(place.formatted_address);
    let geo = {
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng()
    };
    console.log(place.geometry.location.lat())
    setLocation(geo);

    // Estrae i dati dall'API di Google
    var addressComponents = place.address_components;
    console.log(addressComponents)
    let regioneDaMap;
    let cittaDaMap;
    let capDaMap;
    let provinciaDaMap;
    
    for (var i = 0; i < addressComponents.length; i++) {
      const types = addressComponents[i].types;
      
      // Città (località) - UPPERCASE
      if (types.includes('administrative_area_level_3') || types.includes('locality')) {
        cittaDaMap = addressComponents[i].long_name;
        setMapCitta(cittaDaMap?.toUpperCase?.() || cittaDaMap);
      }
      
      // Regione (UPPERCASE)
      if (types.includes('administrative_area_level_1')) {
        regioneDaMap = addressComponents[i].long_name;
        setMapRegione(regioneDaMap?.toUpperCase?.() || regioneDaMap);
      }
      
      // CAP
      if (types.includes('postal_code')) {
        capDaMap = addressComponents[i].long_name;
        setMapCAP(capDaMap);
      }
      
      // Provincia (sigla)
      if (types.includes('administrative_area_level_2')) {
        provinciaDaMap = addressComponents[i].short_name;
        setMapProvincia(provinciaDaMap);
      }
    }
  };

  const handleExportData = () => {
    const csv = generateCsv(csvConfig)(data);
    download(csvConfig)(csv);
  };

  const table = useMaterialReactTable({
    columns,
    data,
    initialState: { showColumnFilters: true },
    createDisplayMode: 'modal', //default ('row', and 'custom' are also available)
    editDisplayMode: 'modal', //default ('row', 'cell', 'table', and 'custom' are also available)
    enableEditing: true,
  // Usa _id come row id per evitare warning/chiavi non uniche
  getRowId: (row) => row._id,
    muiToolbarAlertBannerProps: isLoadingUsersError
      ? {
          color: 'error',
          children: 'Error loading data',
        }
      : undefined,
    muiTableContainerProps: {
      sx: {
        minHeight: '500px',
      },
    },
    onCreatingRowCancel: () => setValidationErrors({}),
    onCreatingRowSave: handleCreateUser,
    onEditingRowCancel: () => setValidationErrors({}),
    onEditingRowSave: handleSaveUser,
   // rowCount: meta?.totalRowCount ?? 0,
    //optionally customize modal content
    /*
    renderTopToolbarCustomActions: () => (
      <Tooltip arrow title="Refresh Data">
        <IconButton onClick={() => refetch()}>
          <RefreshIcon />
        </IconButton>
      </Tooltip>
    ),
*/
    renderCreateRowDialogContent: ({ table, row }) => (

      <>
        <DialogTitle variant="h6">
          {isCreatingUser ? 'Creazione in corso...' : 'Crea deposito'}
        </DialogTitle>
        <DialogContent
          sx={{ display: 'flex', flexDirection: 'column', gap: '0.1rem' }}
        >
          {/* Google Maps Autocomplete */}
          <Autocomplete
            apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
            onPlaceSelected={(place) => HandleonPlacesChanged(place)}
            options={{
              types: ["geocode", "establishment"],
            }}
            defaultValue=""
            placeholder="Inserisci indirizzo..."
            disabled={isCreatingUser}
          />
          <form onSubmit={(e) => e.preventDefault()}>
            {places &&
              <TextField
                label="Regione"
                name="regione"
                id='regione'
                sx={{ input: { color: 'dodgerblue', fontWeight: 'bold' } }}
                value={mapRegione || ''}
                onChange={(e) => setMapRegione(e.target.value.toUpperCase())}
                disabled={isCreatingUser}
                fullWidth
                margin="normal"
                required
              />
            }
            {places &&
              <TextField
                label="Località (Città)"
                name="localita"
                id='localita'
                sx={{ input: { color: 'dodgerblue', fontWeight: 'bold' } }}
                value={mapCitta || ''}
                onChange={(e) => setMapCitta(e.target.value.toUpperCase())}
                disabled={isCreatingUser}
                fullWidth
                margin="normal"
                required
              />
            }
            <TextField
              label="Recapito"
              name="recapito"
              id="recapito"
              onChange={(e) =>
                setValues({ ...values, [e.target.name]: e.target.value })
              }
              disabled={isCreatingUser}
              fullWidth
              margin="normal"
              required
            />
            <TextField
              label="Indirizzo"
              name="indirizzo"
              id="indirizzo"
              sx={{ input: { color: 'dodgerblue', fontWeight: 'bold' } }}
              value={places}
              disabled={isCreatingUser}
              fullWidth
              margin="normal"
              required
              type="text"
            />
            {places &&
              <TextField
                label="CAP"
                name="CAP"
                id="CAP"
                sx={{ input: { color: 'dodgerblue', fontWeight: 'bold' } }}
                value={mapCAP || ''}
                onChange={(e) => setMapCAP(e.target.value)}
                disabled={isCreatingUser}
                fullWidth
                margin="normal"
                required
                type="text"
              />
            }
            {places &&
              <TextField
                label="Provincia"
                name="provincia"
                id="provincia"
                sx={{ input: { color: 'dodgerblue', fontWeight: 'bold' } }}
                value={mapProvincia || ''}
                onChange={(e) => setMapProvincia(e.target.value.toUpperCase())}
                disabled={isCreatingUser}
                fullWidth
                margin="normal"
                required
                type="text"
              />
            }
            {places &&
              <TextField
                label="Latitudine"
                name="lat"
                id="lat"
                sx={{ input: { color: 'orangered' } }}
                InputLabelProps={{ shrink: true }}
                value={location.lat || ''}
                disabled={isCreatingUser}
                fullWidth
                margin="normal"
                required
                type="text"
              />
            }
            {places &&
              <TextField
                label="Longitudine"
                name="lng"
                id="lng"
                InputLabelProps={{ shrink: true }}
                sx={{ input: { color: 'orangered' } }}
                value={location.lng || ''}
                disabled={isCreatingUser}
                fullWidth
                margin="normal"
                required
                type="text"
              />
            }
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 16 }}>
              <Button
                variant="contained"
                color="success"
                onClick={() => handleCreateUser({ table })}
                disabled={isCreatingUser}
              >
                {isCreatingUser ? 'Salvataggio...' : 'Inserisci'}
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => table.setCreatingRow(null)}
                disabled={isCreatingUser}
              >
                Annulla
              </Button>
            </div>
          </form>
        </DialogContent>
      </>
    ),

    //optionally customize modal content

    renderEditRowDialogContent: ({ table, row, internalEditComponents }) => (

      <>
        <DialogTitle variant="h3">Edit User</DialogTitle>
        <DialogContent
          sx={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}
        >
          {internalEditComponents} {/* or render custom edit components here */}
        </DialogContent>
        <DialogActions>
          <MRT_EditActionButtons variant="text" table={table} row={row} />
        </DialogActions>
      </>
    ),

    renderRowActions: ({ row, table }) => (

      <Box sx={{ display: 'flex', gap: '1rem' }}>
        <Tooltip title="Edit">
          <IconButton onClick={() => table.setEditingRow(row)}>
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Delete">
          <IconButton color="error" onClick={() => openDeleteConfirmModal(row)}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </Box>

    ),

    renderTopToolbarCustomActions: ({ table }) => (
     <>
      <Button
        variant="contained"
        onClick={() => {
          table.setCreatingRow(true); //simplest way to open the create row modal with no default values
          //or you can pass in a row object to set default values with the `createRow` helper function
          // table.setCreatingRow(
          //   createRow(table, {
          //     //optionally pass in default values for the new row, useful for nested data or other complex scenarios
          //   }),
          // );
        }}
      >
        Crea Deposito
      </Button>
      <Button variant="outlined"
      disabled={table.getPrePaginationRowModel().rows.length === 0}
      //export all rows, including from the next page, (still respects filtering and sorting)
      onClick={() =>
        handleExportRows(table.getPrePaginationRowModel().rows)
      }
      startIcon={<FileDownloadIcon />}
    >
      Esporta Tabella
    </Button>

    <Button variant="contained"
      disabled={
        !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
      }
      //only export selected rows
      onClick={() => handleExportRows(table.getSelectedRowModel().rows)}
      startIcon={<FileDownloadIcon />}
    >
    Esporta Righe Selezionate
    </Button>
  </>
    ),
    state: {
    //  columnFilters,
   //   globalFilter,
      isSaving: isCreatingUser || isUpdatingUser || isDeletingUser,
      isLoading: isLoadingUsers,
    //  pagination,
      showAlertBanner: isLoadingUsersError,
      showProgressBars: isRefetching,
    //  sorting,
    },
  });

  //CREATE hook (post new user to api)


  return (
    <>
      <MaterialReactTable table={table} />
      <Snackbar
        open={snack.open}
        autoHideDuration={3000}
        onClose={handleSnackClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackClose} severity={snack.severity} sx={{ width: '100%' }}>
          {snack.message}
        </Alert>
      </Snackbar>
    </>
  );
};

function useCreateUser() {
  const { REACT_APP_API_ENDPOINT } = process.env;
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async (garage) => {
      // Invia i dati al server
      const response = await axios.post(
        `${REACT_APP_API_ENDPOINT}/api/garages/garages_create`, 
        garage
      );
      return response.data;
    },
    
    onSuccess: (data) => {
      console.log("Garage creato con successo:", data);
    },
    
    onError: (error) => {
      console.error('Errore durante la creazione del garage:', error);
    },

    // Usa SOLO onSettled per invalidare - evita doppie chiamate
    onSettled: () => {
      // Invalida e refetch immediato
      return queryClient.invalidateQueries({ 
        queryKey: ['table-data'],
        refetchType: 'active' // Refetch solo le query attive
      });
    },
  });
}

//READ hook (get users from api)

function useGetUsers() {

  return useQuery({
    queryKey: ['users'],
    queryFn: async () => {
      //send api request here
      // await new Promise((resolve) => setTimeout(resolve, 1000)); //fake api call
      //  return Promise.resolve(fakeData);

    },
    refetchOnWindowFocus: false,
  });
}

//UPDATE hook (put garage in api)

function useUpdateUser() {
  const { REACT_APP_API_ENDPOINT } = process.env;
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async (garage) => {
      // Invia i dati aggiornati al server
      const response = await axios.post(
        `${REACT_APP_API_ENDPOINT}/api/garages/garages_edit`,
        garage
      );
      return response.data;
    },

    // Rimuovo optimistic update per evitare conflitti
    // L'invalidazione farà un refetch pulito dal server
    
    onSuccess: () => {
      console.log("Garage aggiornato con successo");
    },
    
    onError: (error) => {
      console.error('Errore durante l\'aggiornamento del garage:', error);
    },
    
    onSettled: () => {
      return queryClient.invalidateQueries({ 
        queryKey: ['table-data'],
        refetchType: 'active'
      });
    },
  });

}

//DELETE hook (delete garage in api)

function useDeleteUser() {
  const { REACT_APP_API_ENDPOINT } = process.env;
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (garageId) => {
      // Invia la richiesta di eliminazione al server (DELETE con body JSON)
      const response = await axios.delete(
        `${REACT_APP_API_ENDPOINT}/api/garages/garage_delete`,
        {
          data: { _id: garageId },
          headers: { 'Content-Type': 'application/json' },
        }
      );
      return response.data;
    },

    // Rimuovo optimistic update per evitare conflitti
    
    onSuccess: () => {
      console.log("Garage eliminato con successo");
    },
    
    onError: (error) => {
      console.error('Errore durante l\'eliminazione del garage:', error);
    },

    onSettled: () => {
      return queryClient.invalidateQueries({ 
        queryKey: ['table-data'],
        refetchType: 'active'
      });
    },
  });

}




const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5000, // I dati sono considerati freschi per 5 secondi
      refetchOnWindowFocus: false, // Non refetch automatico quando la finestra torna in focus
      retry: 1, // Riprova solo 1 volta in caso di errore
    },
    mutations: {
      retry: 0, // Non riprovare le mutazioni in caso di errore
    },
  },
});

const Garages = () => (
  //App.tsx or AppProviders file. Don't just wrap this component with QueryClientProvider! Wrap your whole App!
  <QueryClientProvider client={queryClient}>
    <Example />
  </QueryClientProvider>
);

export default Garages;

const validateRequired = (value) => !!value || !!value?.length;

function validateGarage(garage) {
  return {
    regione: !validateRequired(garage.regione) ? 'Regione è richiesta' : '',
    recapito: !validateRequired(garage.recapito) ? 'Recapito è richiesto' : '',
    localita: !validateRequired(garage.localita) ? 'Località è richiesta' : '',
    indirizzo: !validateRequired(garage.indirizzo) ? 'Indirizzo è richiesto' : '',
    CAP: !validateRequired(garage.CAP) ? 'CAP è richiesto' : '',
    provincia: !validateRequired(garage.provincia) ? 'Provincia è richiesta' : '',
    lat: !validateRequired(garage.lat) ? 'Latitudine è richiesta' : '',
    lng: !validateRequired(garage.lng) ? 'Longitudine è richiesta' : '',
  };
}